// useTableSchema.js

import { useNodeTypes } from 'context/NodeTypesContext';

import useTableFields from 'views/table/hooks/useTableFields';

const useTableSchema = ({ enforceExplicitProperties = false, typeDef, view }) => {
    const { getRevision } = useNodeTypes();
    const nodeTypesRevision = getRevision();

    return useTableFields({
        enforceExplicitProperties,
        typeDef,
        view,
        nodeTypesRevision,
    });
};

export default useTableSchema;
